import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/shared/types/state';

export const selectAnyFormDirty = createSelector(
  (state) => state.forms,
  (slice) => Object.values(slice.forms).some((isDirty) => isDirty)
);

export const selectIsFormDirty = (state: RootState, formId: string) => !!state.forms.forms[formId];
